<template>
  <div id="base-search">
    <input
      ref="mvmntSearch"
      v-model="searchTermLocal"
      title="search"
      :class="{ focus: isFocus }"
      type="search"
      placeholder="Search artists, episodes, shows, cities or anything"
      :maxlength="searchMaxLength"
      @focus="isFocus = true"
      @blur="isFocus = false"
      @keyup.enter="onSearch"
      @keydown="inputValidation"
      @keyup.esc="resetSearch"
    />
    <span v-if="isLoading" class="focus-loading">
      <Loading color="black" />
    </span>
    <button
      v-if="searchTerm.length && !isLoading"
      type="button"
      class="focus-close"
      @click="resetSearch"
    >
      clear
    </button>
    <span class="focus-border" />
  </div>
</template>
<script>
import Loading from '@/components/ui/Loading.vue';
export default {
  name: 'BaseSearch',
  components: {
    Loading
  },
  props: {
    delay: {
      type: Number,
      required: false,
      default: () => Number(500)
    },
    searchTerm: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      loadingLocal: this.loading,
      searchTermLocal: '',
      isFocus: false,
      searchMaxLength: 25
    };
  },
  computed: {
    isLoading() {
      return this.loadingLocal;
    },
    isQueryEqualsSearchTerm(){
      return this.$route.query.s !== this.searchTermLocal;
    },
    minMaxSearchLimit(){
      return this.searchTermLocal.length >= 3 && this.searchTermLocal.length <= this.searchMaxLength;
    }
  },
  watch: {
    searchTerm(v) {
      this.searchTermLocal = v;
    },
    searchTermLocal(v){
      this.$emit('update:search-term', v);
    },
    loading(v) {
      this.loadingLocal = v;
    },
    isFocus(isFocused) {
      isFocused
        ? window.removeEventListener('keydown', this.inputFocus, { once: true })
        : window.addEventListener('keydown', this.inputFocus, { once: true });
    }
  },
  async mounted() {
    await this.$nextTick();
    this.inputFocus();
  },
  activated() {
    this.inputFocus();
    window.addEventListener('keydown', this.inputFocus, { once: true });
  },
  deactivated() {
    window.removeEventListener('keydown', this.inputFocus, { once: true });
  },
  methods: {
    inputValidation(event){
      const alphaNumeric = new RegExp('^[a-zA-Zα-ωΑ-Ω\\d\\s]*$'); //
      if (!alphaNumeric.test(event.key)) {
        event.preventDefault();
      }
    },
    inputFocus() {
      this.$refs.mvmntSearch.focus();
    },
    onSearch() {
      if (this.minMaxSearchLimit && this.isQueryEqualsSearchTerm) { // harsh control on enter button
        this.$emit('update:loading', true);
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => { // debounce to avoid spam hits on enter key
          this.$emit('on-search', this.searchTerm);
        }, this.delay);
      }
    },
    resetSearch() {
      this.searchTermLocal = '';
      this.$emit('on-reset');
      this.$refs.mvmntSearch.focus();
      if (this.$route.query.s !== '') {
        this.$router.replace({query: {s: ''}});
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/sass/components/search/_base-search-input.scss";
</style>
